import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Card, CardContent, Container, TextField, Typography } from '@mui/material';
import QRCode from 'react-qr-code';
import { adminLevel } from '../../axiosLib/services/institution/admin';
import { get } from 'lodash';

export default function QrCodeGeneratorPage() {
  const [link, setLink] = useState('');
  const svgRef = useRef(null);
  const [canScanQrCode, setCanScanQrCode] = useState(false);

  // On mount, read preLoadedLink param from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const preLoaded = params.get('preLoadedLink') || '';
    if (preLoaded.trim() !== '') {
      setLink(preLoaded);
    }
  }, []);

  useEffect(() => {
    adminLevel((error, data) => {
      if (!error) {
        setCanScanQrCode(get(data, 'admin.roleSet', []).includes('MOBILE_OMR_SCAN'));
      } else {
        console.log(error);
      }
    });
  }, []);

  // Sanitize filename by removing invalid filename characters
  const sanitizeFilename = (filename) => {
    return filename.replace(/[^a-z0-9_\-\.]/gi, '_');
  };

  const downloadQrCode = () => {
    if (!svgRef.current) return;

    const svgElement = svgRef.current.querySelector('svg');
    if (!svgElement) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);

    const img = new Image();
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(img, 0, 0);

      const pngUrl = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = pngUrl;

      // Use sanitized link as filename or fallback to qr-code.png
      let filename = sanitizeFilename(link);
      if (!filename) filename = 'qr-code';
      if (!filename.toLowerCase().endsWith('.png')) {
        filename += '.png';
      }

      a.download = filename;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url);
    };

    img.onerror = (err) => {
      console.error('Failed to load SVG image', err);
      URL.revokeObjectURL(url);
    };

    img.src = url;
  };

  return (
    <div>
      {canScanQrCode ? (
        <Container maxWidth="sm" sx={{ mt: 4, textAlign: 'center' }}>
          <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
            <CardContent
              style={{
                backgroundColor: 'beige',
                color: '#800000',
                fontWeight: 'bold',
                fontSize: '20px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              QR Code Generator
            </CardContent>
          </Card>

          <TextField
            label="Enter URL or Text"
            variant="outlined"
            fullWidth
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="Write anything ..."
          />

          <Box mt={4} ref={svgRef}>
            {link ? (
              <QRCode
                value={link}
                size={380}
                bgColor="#ffffff"
                fgColor="#000000"
                level="Q"
                includeMargin={true}
                renderAs="svg"
              />
            ) : (
              <Typography color="text.secondary">Enter a link above to generate QR code</Typography>
            )}
          </Box>

          {link && (
            <Button variant="contained" sx={{ mt: 3 }} onClick={downloadQrCode}>
              Download QR Code
            </Button>
          )}
        </Container>
      ) : (
        <Container maxWidth="sm" sx={{ mt: 4, textAlign: 'center' }}>
          <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
            <CardContent
              style={{
                backgroundColor: 'beige',
                color: '#800000',
                fontWeight: 'bold',
                fontSize: '20px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              Access Is Denied
            </CardContent>
          </Card>
        </Container>
      )}
    </div>
  );
}
